import SelectableEntity from '@/models/Shared/SelectableEntity';
import OpportunityDto from '@/models/Opportunities/OpportunityDto';

export default class CampaignBrowseOpportunitiesViewModel {
    opportunities: SelectableEntity<OpportunityDto>[] = [];
    selectedOpportunityId = '';
    selectedOpportunityIds: string[] = [];
    selectedOpportunity: OpportunityDto | null = null;
}
